/**
 * @module To Do List
 */
import {getField, updateField} from 'vuex-map-fields';

export default {
    namespaced: true,
    state: {
        myErrors: [],
        resourceId: 0,
        type: 0,
        showHideModalDelete: false,
        showHideModalCreate: false,
        fromIncome: false,
        teamListByMappingId: [],
        teamList: [],
        teamEdit: [],
        operationListAuction: [],
        operationListMapping: [],
        showTableReadMode: true,
        saveOk: false,
        bread_list: [],
        bread_active: {
            'label': 'Il mio Team'
        },
        p_modules: [],
        p_operations: [],
        p_cards: [],
        default_modules: [

            {
                id: 2,
                label: 'Tutte le Aste'
            },
            {
                id: 3, // will become 3
                label: 'Tutte le operazioni a Mercato Libero'
            }
        ],

        default_cards: [
            {
                id: 1,
                label: 'Dettaglio Immobile',
            },
            {
                id: 2,
                label: 'Conto economico',
            },
            {
                id: 3,
                label: 'Team',
            },
            {
                id: 4,
                label: 'Risorse',
            },
            {
                id: 5,
                label: 'To Do',
            }

        ],
        cards: [],
        modules: [],
        formData: {
            name: '',
            profession: '',
            email: '',
            phone: ''
        },
        rating: {
            storeModule: 'team',
            questionRate: '<strong>Valuta</strong> la gestione del Team',
            section: 'Team Creazione',
            showHideModalRating: false,
        },
        boom: {
            showHideModalBoom: true,
        }
    },
    getters: {
        getField,
    },
    mutations: {
        updateField,

        fromIncomeSet: function (state, data) {
            state.fromIncome = data.fromIncome;
        },

        typeAndResourceSet: function (state, data) {
            state.resourceId = data.resourceId;
            state.type = data.type;
        },

        myErrors: function (state, data) {
            state.myErrors = data;
        },
        teamListByMappingSet: function (state, data) {
            state.teamListByMappingId = data;

        },
        teamListSet: function (state, data) {
            state.teamList = data;

        },
        teamEditSet: function (state, data) {

            state.formData = data;
            state.modules = state.default_modules;
            state.p_modules = data.modulo;

            state.p_operations = data.risorsa;

            state.cards = state.default_cards;
            state.p_cards = data.part;
        },

        teamNewSet: function (state) {
            state.modules = state.default_modules;
            state.cards = state.default_cards;
            state.p_modules = [];
            state.p_operations = [];
            state.p_cards = [];
        },
        showTableReadModeSet: function (state, boolean) {
            state.showTableReadMode = boolean;
        },
        saveOkSet: function (state, boolean) {
            state.saveOk = boolean;
        },
        showHideDeleteModalSet: function (state) {
            state.showHideModalDelete = !state.showHideModalDelete;
        },
        showHideModalCreateSet: function (state) {
            state.showHideModalCreate = !state.showHideModalCreate;
        },
        operationListAuctionSet: function (state, data) {
            state.operationListAuction = data;
        },
        operationListMappingSet: function (state, data) {

            state.operationListMapping = data;
        },

    },
    actions: {

        save: function (state) {

            axios.post('/api/v1/team/save', {
                name: state.state.formData.name,
                email: state.state.formData.email,
                phone: state.state.formData.phone,
                password: state.state.formData.password,
                profession: state.state.formData.profession,
                id: state.state.formData.id,
                p_modules: state.state.p_modules,
                p_operations: state.state.p_operations,
                p_cards: state.state.p_cards,
            })
                .then(function (response) {
                    state.commit('saveOkSet', true);
                    state.dispatch('classicList');
                    state.dispatch('clearForm');
                    state.dispatch('showHideModalCreate');
                    state.dispatch('clearError');
                    if (state.state.fromIncome === true) {
                        state.dispatch('add', {resourceId: state.state.resourceId, type: state.state.type, id: response.data});
                    }

                   //state.dispatch('openCloseRatingModal');
                })
                .catch(function (error) {
                    state.commit('myErrors', error.response.data.errors);
                })
        },

        listByMapping: function (state, data) {

            axios.get('/api/v1/team/' + data.resourceId + '/' + data.type + '/mapping')
                .then(function (response) {
                    state.commit('teamListByMappingSet', response.data.data);
                    state.commit('showTableReadModeSet', true);
                })
                .catch(error => {
                    if (error.response) {
                        state.dispatch('user/checkErrorMessage', error.response, {root: true});
                    }
                });
        },

        classicList: function (state) {
            axios.get('/api/v1/team/classicList')
                .then(function (response) {
                    state.commit('teamListSet', response.data);
                })
                .catch(error => {
                    if (error.response) {
                        state.dispatch('user/checkErrorMessage', error.response, {root: true});
                    }
                });
        },

        list: function (state, data) {
            axios.get('/api/v1/team/list/' + data.resourceId + '/' + data.type)
                .then(function (response) {
                    state.commit('teamListSet', response.data);
                    state.commit('showTableReadModeSet', false);
                })
                .catch(error => {
                    if (error.response) {
                        state.dispatch('user/checkErrorMessage', error.response, {root: true});
                    }
                });
        },

        newMember: function (state, data) {
            state.commit('fromIncomeSet', data);
            state.commit('typeAndResourceSet', data);
            state.dispatch('clearForm');
            state.commit('teamNewSet');
            state.dispatch('operationList', {type: 2});
            state.dispatch('operationList', {type: 1});

        },

        edit: function (state, id) {
            axios.get('/api/v1/team/' + id + '/edit')
                .then(function (response) {
                    state.commit('teamEditSet', response.data.data);

                    // if user chooses Auction, he can access every Auction operations
                    if (response.data.data.modulo.indexOf(2) === -1) {
                        state.dispatch('operationList', {type: 2});
                    }

                    // if user chooses Custom, he can access every Custom operations
                    if (response.data.data.modulo.indexOf(1) === -1) {
                        state.dispatch('operationList', {type: 1});
                    }
                })
                .catch(error => {
                    if (error.response) {
                        state.dispatch('user/checkErrorMessage', error.response, {root: true});
                    }
                });
        },


        add: function (state, data) {
            axios.post('/api/v1/team/', {
                id: data.id,
                resourceId: data.resourceId,
                type: data.type
            })
                .then(function () {
                    state.dispatch('listByMapping', data);
                    if (state.state.fromIncome === false) {
                        state.commit('showTableReadModeSet', false);
                    }
                    state.dispatch('todo/teamList', null, {root: true});
                })
                .catch(error => {
                    if (error.response) {
                        state.dispatch('user/checkErrorMessage', error.response, {root: true});
                    }
                });
        },

        /**
         * Claring form everyWhere
         * @param state
         */
        clearForm: function (state) {
            for (let f in state.state.formData) {
                state.state.formData[f] = ' ';
            }
        },

        showHideDeleteModal: function (state) {
            state.commit('showHideDeleteModalSet');
        },

        deleteTeam: function (state, data) {
            axios.get('/api/v1/team/' + data.id + '/delete')
                .then(function () {
                    state.dispatch('classicList');
                })
        },

        operationList: function (state, data) {

            if (data.type === 3) {
                data.type = 1; // forced to view everything
            }
            axios.get('/api/v1/operation/starred/' + 1 + '/' + data.type)
                .then(function (response) {
                    if (data.type === 2) {
                        state.commit('operationListAuctionSet', response.data.data);
                    }
                    if (data.type === 1 || data.type === 3) {

                        state.commit('operationListMappingSet', response.data.data);
                    }
                })
                .catch(error => {
                    if (error.response) {
                        state.dispatch('user/checkErrorMessage', error.response, {root: true});
                    }
                });
        },

        showHideModalCreate: function (state) {
            state.commit('showHideModalCreateSet');

        },

        clearError: function (state) {
            state.commit('myErrors', []);
        },

        openCloseBoomModal: function(state)
        {
            state.state.boom.showHideModalBoom = false;
        },

        openCloseRatingModal: function(state)
        {

            axios.post('/api/v1/rating/checkRatingDone', {
                area: state.state.rating.section
            })
                .then(function(response){
                    if(response.data === false)
                    {
                        state.state.rating.showHideModalRating = !state.state.rating.showHideModalRating;
                    }
                    else {
                        state.state.rating.showHideModalRating = false;
                    }


                })
                .catch(function(error){

                })

        }
    }
}